// eslint-disable-next-line import/prefer-default-export
export const UNKNOW_ERROR = "Some error occurred. Please try again later.";
export const NO_INTERNET = "No Internet";
export const CONNECTION_FAILED = "Connection with the server failed";
export const TOKEN_EXPIRED = "The token is not valid. Please login.";
